module.exports = __webpack_public_path__ + "static/media/Salvataggio_Configurazione.b5adcdb2.mp4";